import { APP_CONFIG } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { bootstrapApplication } from "@angular/platform-browser";

bootstrapApplication(AppComponent, APP_CONFIG);